import { WorkflowLegendItem } from '@idw-types/workflow-legend-item';
import styles from './workflow-legend-container.less';

type WorkflowLegendContainerProps = {
    items: Array<WorkflowLegendItem>;
}

export const WorkflowLegendContainer = (props: WorkflowLegendContainerProps) => {
    const { items } = props;

    return <div className={styles.workflowLegendContainer}>
        <h6>{"Legend"}</h6>
        <div className={styles.legendItemsContainer}>
            {items.map((legendItem, index) => {
                return <div key={index} className={styles.legendItem}>
                    <span className={`${styles.legendColor} ${legendItem.borderStyle}`} style={{ backgroundColor: legendItem.color }}> </span>
                    <span className={styles.legendLabel}>{legendItem.label}</span>
                </div>
            })}
        </div>
    </div>
}